const indexItems = [
  { title: '动作片', count: '1280部', icon: 'ri-sword-line', color: 'text-primary-500 bg-primary-100' },
  { title: '喜剧片', count: '960部', icon: 'ri-emotion-laugh-line', color: 'text-accent-500 bg-accent-100' },
  { title: '爱情片', count: '850部', icon: 'ri-heart-line', color: 'text-primary-500 bg-primary-100' },
  { title: '科幻片', count: '720部', icon: 'ri-rocket-line', color: 'text-secondary-500 bg-secondary-100' },
  { title: '恐怖片', count: '540部', icon: 'ri-ghost-line', color: 'text-accent-500 bg-accent-100' },
  { title: '国产剧', count: '2100部', icon: 'ri-tv-line', color: 'text-primary-500 bg-primary-100' },
  { title: '韩剧', count: '680部', icon: 'ri-kakao-talk-line', color: 'text-secondary-500 bg-secondary-100' },
];

export default function IndexSection() {
  return (
    <section id="index" className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="font-heading font-bold text-2xl md:text-3xl text-foreground-950 mb-3">
            分类索引
          </h2>
          <p className="text-foreground-500 text-sm md:text-base max-w-xl mx-auto">
            按类型快速浏览，找到你想看的影视内容
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-7 gap-3 max-w-5xl mx-auto">
          {indexItems.map((item, i) => (
            <div
              key={i}
              className="bg-background-50 rounded-xl p-4 border border-background-200 hover:border-primary-300 cursor-pointer transition-all text-center"
            >
              <div className={`w-10 h-10 mx-auto flex items-center justify-center rounded-xl ${item.color} mb-3`}>
                <i className={`${item.icon} text-lg`}></i>
              </div>
              <h3 className="font-heading font-semibold text-foreground-950 text-sm mb-1">
                {item.title}
              </h3>
              <p className="text-xs text-foreground-400">{item.count}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}